import selectEntity from '../selectors/selectEntity'
import { createAlert } from './alertActions'
import { CALL_API, REQUEST_GET, REQUEST_PUT } from '../middleware/api'
import { BRANDING } from '../schemas'
import { ERROR, SUCCESS } from '../components/AlertListItem'

export const FETCH_BRANDING_REQUEST = 'tru/brandings/FETCH_BRANDING_REQUEST'
export const FETCH_BRANDING_SUCCEEDED = 'tru/brandings/FETCH_BRANDING_SUCCEEDED'
export const FETCH_BRANDING_FAILED = 'tru/brandings/FETCH_BRANDING_FAILED'
export const UPDATE_BRANDING_REQUEST = 'tru/brandings/UPDATE_BRANDING_REQUEST'
export const UPDATE_BRANDING_SUCCEEDED =
  'tru/brandings/UPDATE_BRANDING_SUCCEEDED'
export const UPDATE_BRANDING_FAILED = 'tru/brandings/UPDATE_BRANDING_FAILED'
export const UPDATE_LOGO_REQUEST = 'tru/brandings/UPDATE_LOGO_REQUEST'
export const UPDATE_LOGO_SUCCEEDED = 'tru/brandings/UPDATE_LOGO_SUCCEEDED'
export const UPDATE_LOGO_FAILED = 'tru/brandings/UPDATE_LOGO_FAILED'

export const fetchBranding = (company, id) => ({
  [CALL_API]: {
    types: [
      FETCH_BRANDING_REQUEST,
      FETCH_BRANDING_SUCCEEDED,
      FETCH_BRANDING_FAILED
    ],
    endpoint: `companies/${company.id}/brandings/${id}.json`,
    requestType: REQUEST_GET,
    schema: BRANDING
  }
})

const updateBrandingRequest = (company, id, attributes) => ({
  [UPDATE_BRANDING_SUCCEEDED]: {
    alert: {
      type: SUCCESS,
      message: 'Branding has been updated'
    }
  },
  [CALL_API]: {
    types: [
      UPDATE_BRANDING_REQUEST,
      UPDATE_BRANDING_SUCCEEDED,
      UPDATE_BRANDING_FAILED
    ],
    endpoint: `companies/${company.id}/brandings/${id}.json`,
    requestType: REQUEST_PUT,
    schema: BRANDING,
    data: { branding: attributes }
  }
})

const handleUpdateError = (error, dispatch) => {
  let message
  switch (error.status) {
    case 400:
      message = 'Domain name has already been taken'
      break
    default:
      message = 'There was a problem updating the branding. Please try again.'
  }

  dispatch(createAlert({ type: ERROR, message }))
}

const shouldReloadDomain = (branding, currentUser) => {
  return (
    currentUser.branding.id === branding.id &&
    currentUser.branding.domainName !== branding.domainName
  )
}
const handleUpdateSuccess = (branding, currentUser) => {
  if (shouldReloadDomain(branding, currentUser)) {
    window.location = `https://${branding.domainName}${window.location.pathname}${window.location.hash}`
  }
}

const handlePostUpdate = (action, dispatch, getState) => {
  if (action.error) {
    handleUpdateError(action.error, dispatch)
  } else {
    const { response } = action
    const branding = selectEntity(response.entities.brandings, response.result)

    handleUpdateSuccess(branding, getState().currentUser)
  }
}

export const updateBranding = (company, id, attributes) => {
  return (dispatch, getState) => {
    return dispatch(updateBrandingRequest(company, id, attributes)).then(
      action => handlePostUpdate(action, dispatch, getState)
    )
  }
}

const replaceLogo = image => {
  $('.logo')
    .find('img')
    .attr('src', image.logo)
}

export const updateLogoRequest = () => ({ type: UPDATE_LOGO_REQUEST })
export const updateLogoSucceeded = branding => {
  replaceLogo(branding.image)

  return {
    type: UPDATE_LOGO_SUCCEEDED,
    entities: {
      brandings: {
        [branding.id]: { image: branding.image }
      }
    }
  }
}

export const updateLogoFailed = () => ({
  type: UPDATE_LOGO_FAILED,
  alert: {
    type: ERROR,
    message: 'There was a problem updating the logo. Please try again.'
  }
})

const removeLogoRequest = (company, id) => ({
  [CALL_API]: {
    types: [UPDATE_LOGO_REQUEST, UPDATE_LOGO_SUCCEEDED, UPDATE_LOGO_FAILED],
    endpoint: `companies/${company.id}/brandings/${id}/remove_image.json`,
    requestType: REQUEST_PUT,
    schema: BRANDING
  }
})

export const removeLogo = (company, id) => {
  return dispatch => {
    return dispatch(removeLogoRequest(company, id)).then(action => {
      replaceLogo(action.response.entities.brandings[id].image)
    })
  }
}



// WEBPACK FOOTER //
// ../src/actions/brandingActions.js